
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-games-for-your-site",
      function () {
        return require("private-next-pages/free-games-for-your-site/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-games-for-your-site"])
      });
    }
  